import React from 'react'
import { useTranslation } from 'react-i18next'
import { Image } from 'react-native'
import { useInvoiceDetailsContext } from '../../../TabInvoice/InvoiceDetailsContext'
import { SuccessFailurePrompt } from '../../../../../ui/molecules/SuccessFailurePrompt'
import loadingGif from '../../../../../assets/loading-gif.gif'

export const PaymentProcessingAlert = ({ navigation }) => {
  const { paymentProcessingModal } = useInvoiceDetailsContext()
  const { t } = useTranslation('global')
  return (
    <SuccessFailurePrompt
      visible={paymentProcessingModal}
      onDismiss={() => navigation.goBack()}
      contentContainerStyle={{ marginHorizontal: 50 }}
      title={t('PaymentProcessingAlert.title')}
      icon={
        <Image
          style={{ width: 100, height: 100, marginTop: 40 }}
          source={{ uri: loadingGif }}
        />
      }
      message={t('PaymentProcessingAlert.message')}
      exitable={false}
    />
  )
}
